import React from 'react';
import { EmptyLayout, MainLayout } from 'components/layout';

const Home = React.lazy(() => import("components/Home"));
const Login = React.lazy(() => import("components/login/Login"));
const Error404 = React.lazy(() => import("components/Error404"));

export const routes = [
    {
        component: Home,
        exact: true,
        path: "/",
        authRequired: true,
        layout:MainLayout,
    },
    {
        component: Login,
        exact: true,
        path: "/login",
        authRequired: false,
        layout:EmptyLayout,
    },
    {
        component: Error404,
        exact: false,
        path: "*",
        authRequired: false,
        layout:EmptyLayout,
    },
];
